import { EnrollmentContextService } from "../../../hoc/context/enrollment/enrollment-context";

export const gaSuccessEventExtensions = (
	enrollmentCtxt: EnrollmentContextService
) => {
	return {};
};

export const gaChangeExtensions = (e: Event) => {
	return null;
};
